"use client";

import { useTranslations } from "next-intl";
import { usePathname, Link } from "@/i18n/navigation";
import { PhoneIcon, MapPinIcon } from "@heroicons/react/24/outline";
import { trackPhoneClick } from "../../lib/tracking";

const PHONE_NUMBER = "+32 (0)493 96 65 07";
const PHONE_LINK = "+32493966507";

export default function TopBar() {
  const pathname = usePathname();
  const t = useTranslations("Nav");
  if (pathname?.startsWith("/admin")) return null;

  return (
    <div className="relative z-40 hidden -mb-7 w-full bg-brand-900 pb-7 text-white lg:block">
      <div className="flex items-center justify-between gap-4 px-4 py-2 text-xs font-semibold sm:px-6 lg:px-8">
        <div className="flex items-center gap-4">
          <a
            href={`tel:${PHONE_LINK}`}
            onClick={(e) => trackPhoneClick(e, { phoneNumber: PHONE_LINK, location: "topbar" })}
            className="flex items-center gap-1.5 transition hover:text-white/80"
          >
            <PhoneIcon className="h-3.5 w-3.5" />
            {PHONE_NUMBER}
          </a>
          <span className="h-3 w-px bg-white/20" />
          <span className="flex items-center gap-1.5 text-white/85">
            <MapPinIcon className="h-3.5 w-3.5" />
            {t("topBarZone")}
          </span>
        </div>

        <Link href="/blog" className="transition hover:text-white/80">
          {t("blog")}
        </Link>
      </div>
    </div>
  );
}
